export default {
  BusinessPurchaseSupplier: {
    header: {
      code: '供应商编码',
      name: '供应商名称',
      classify: '项目',
    },
    export: {
      downLoadName: '供应商导出',
      excelImport: '导入',
      export: '导出',
      rules: 'Excel导入供应商规则说明',
      p1: '如果系统已存在供应商编码资料，根据供应商编码更新数据，否则新建供应商信息',
      p2: '导入供应商信息模板，点击下载',
      title: '供应商信息模板',
      p3: '导入Excel格式必须带标题，红色标题为必填；Excel的列请设置为文本格式，不然可能会出现类型转换错误的问题',
      p4: '支持：csv、xls、xlsx格式，一次导入文件大小不能超过128MB，数据行不能超过6万行，如果超过，请分成多次导入。'
    },

    table: {
      code: '供应商编码',
      name: '供应商名称',
      classify: '项目',
      supplierGrade: '供应商等级',
      proportion: '溢装比例',
      week: '送货周期',
      invoicing: '默认开票',
      taxRate: '默认税率',
      paymentMethod: '默认结算方式',
      company: '公司全称',
      mnemonicCode: '助记码',
      cooperationDate: '合作日期',
      contactPerson: '联系人',
      telephone: '电话',
      phone: '手机',
      address: '地址',
      email: '邮箱',
      account: '账户名称',
      bankOfDeposit: '开户银行',
      bankAccount: '银行账号',
      remark: '备注',
      changeTime: '修改时间',
    },

    dataForm: {
      title: '供应商信息',
      titleBtn: '操作日志',
      code: '供应商编码',
      name: '供应商名称',
      classify: '项目',
      company: '公司全称',
      supplierGrade: '供应商等级',
      mnemonicCode: '助记码',
      week: '送货周期',
      proportion: '溢装比例',
      cooperationDate: '合作日期',
      invoicing: '默认开票',
      paymentMethod: '默认结算方式',
      taxRate: '默认税率',
      remark: '备注',
      contactPerson: '联系人',
      email: '邮箱',
      telephone: '电话',
      phone: '手机',
      address: '地址',
      account: '账户名称',
      bankOfDeposit: '开户银行',
      bankAccount: '银行账号',
      cooperationDateText: '选择日期时间',
      contact: '联系方式',
      detailAddress: '详细地址',
      bankInformation: '银行信息',
      codeRule: '请输入供应商编码',
      nameRule: '请输入供应商名称',
      edit: '编辑',
      add: '新建',
      warning1: '供应商',
      warning2: '日志',
      day: '天',
      taxCode: '税务编码',
      currency: '货币',
      gl_Account: 'GI账户号',
      systemCode: '系统编码',
    }

  }
};
